import React, { useEffect, useState } from 'react'
import Axios from 'axios'
import Chart from '../chart'
import Table from '../table'
import DataLayout from '../data-layout'

const SpendingByCharCode = ({
  match: {
    params: { year, deptNo, charCode }
  },
  location
}) => {
  const [data, setData] = useState([])

  useEffect(() => {
    const loadData = async () => {
      const result = await Axios.get(
        `/GetDepartmentSpending/${year}/${deptNo}/${charCode}`
      )
      const _data = result.data.map(d => ({
        name: d.OrgName.trim(),
        nameClick: `/department/${year}/${deptNo}/${charCode}/${d.ObjCode.trim()}${
          location.search
        }&objDesc=${d.OrgName.trim()}`,
        data: d.CurrentYearActual
      }))
      setData(_data.sort((a, b) => b.data - a.data))
    }

    loadData()
  }, [charCode, deptNo, location.search, year])

  return (
    <DataLayout year={year}>
      <Chart data={data} />
      <Table
        data={{
          headers: [
            {
              title: 'Category',
              dataKey: 'name',
              clickThrough: 'nameClick'
            },
            {
              title: 'Amount',
              dataKey: 'data'
            }
          ],
          data
        }}
      />
    </DataLayout>
  )
}

export default SpendingByCharCode
